import React from "react";
import "./DireccionContacto.css"

export default function DireccionContacto(){
  return(
    <div className="direccion-main">
      <div className="direccion-main-info">
        <div className="direccion-info">
          <div className="direccion-contacto">
            <h1>
              Contacto
            </h1>
            <p>
              Holistique es un Health & Beauty Hub que conecta a los profesionales con tecnologías, productos e insumos especializados para estética, dermatología, cirugía plástica y medicina regenerativa, ofreciendo soluciones seguras, científicas y orientadas a resultados reales.
            </p>
          </div>
          <div className="direccion-ubicacion">
            <h1>
              Ubicacion
            </h1>
            <p>
              Dirección: Calle 70, San José, Nunciatura.
            </p>
          </div>
          <div className="direccion-horario">
            <h1>
              Horario
            </h1>
            <p>
              Lunes a Viernes <br /> De 8 am a 5 pm.
            </p>
          </div>
        </div>
        <div className="direccion-map">
          <iframe
            title="Mapa Holistique"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1993.7552562535486!2d-84.1105294110545!3d9.937002721264736!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8fa0e302d27bbd33%3A0xae725156463adeda!2sHOLISTIQUE%20Health%20%26%20Beauty%20Hub!5e1!3m2!1sen!2scr!4v1762362836740!5m2!1sen!2scr"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
      <div className="direccion-button">
        <a href="https://wa.me/50670159340">Contactar a un Ejecutivo</a>
      </div>
    </div>  
  );
}